import { render } from "./TradeWorldMap.vue?vue&type=template&id=20334df5&scoped=true&ts=true"
import script from "./TradeWorldMap.vue?vue&type=script&lang=ts"
export * from "./TradeWorldMap.vue?vue&type=script&lang=ts"

import "./TradeWorldMap.vue?vue&type=style&index=0&id=20334df5&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20334df5"]])

export default __exports__